import { revokeToken, signOut } from 'modules/authentication/actions'

export const handleLogout = async (dispatch, history, token, panelOpen, closePanel) => {
    if (sessionStorage) {
        sessionStorage.clear()
    }
    if (panelOpen) {
        closePanel()
    }
    await dispatch(revokeToken(token))
    return await dispatch(signOut(history))
}
